import { createContext } from 'react'

export const VoterRegistrationUserContext = createContext()
